import getPermissions from "./utils/getPermissions";
import omitEmpty from "./utils/omitEmpty";
export default {
    get: function (token) {
        var merchantIdRestrictions = token.getRestrictions({
            service: "merchant",
            resource: "merchants",
            action: "read",
            restriction: "merchantId"
        });
        var canRead = getPermissions(token, "merchant", ["merchants"], ["read"]);
        var merchants = {
            read: canRead,
            readAll: canRead && !merchantIdRestrictions,
            create: getPermissions(token, "merchant", ["merchants"], ["create"]),
            update: getPermissions(token, "merchant", ["merchants"], ["update"])
        };
        var employees = {
            read: getPermissions(token, "merchant", ["employees"], ["read"]),
            canGhost: getPermissions(token, "merchant", ["admin-ghost-merchant"], ["create"]),
            canGenerateOnboardingLink: getPermissions(token, "merchant", ["employee-onboarding-url"], ["create"]),
            detach: getPermissions(token, "merchant", ["unattach-employee"], ["delete"])
        };
        var locations = {
            create: getPermissions(token, "merchant", ["locations"], ["create"]),
            createOffers: getPermissions(token, "cashback", ["merchant-location-offers"], ["create"]),
            delete: getPermissions(token, "merchant", ["locations"], ["delete"])
        };
        var canViewMerchantDetails = getPermissions(token, "merchant", ["merchants"], ["read"]) &&
            getPermissions(token, "merchant", ["locations"], ["read"]) &&
            getPermissions(token, "cashback", ["merchant-offers"], ["read"]) &&
            getPermissions(token, "cashback", ["transactions"], ["read"]) &&
            getPermissions(token, "cashback", ["merchant-location-offers"], ["read"]) &&
            getPermissions(token, "cashback", ["transaction-location-totals"], ["read"]);
        var canViewMerchantLocations = getPermissions(token, "merchant", ["merchants"], ["read"]) &&
            getPermissions(token, "merchant", ["locations"], ["read"]) &&
            getPermissions(token, "cashback", ["merchant-location-offers"], ["read"]) &&
            getPermissions(token, "cashback", ["transaction-location-totals"], ["read"]);
        var permission = {
            merchants: omitEmpty(merchants),
            employees: omitEmpty(employees),
            locations: omitEmpty(locations),
            canViewMerchantDetails: canViewMerchantDetails,
            canViewMerchantLocations: canViewMerchantLocations
        };
        return omitEmpty(permission);
    }
};
